import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ActionCardConfigInterface {
  shadow?: boolean;
  title?: string;
  body?: string;
  bgColor?: string;
  selected?: boolean;
  image?: string;
  label?: string;
  labelSub?: string;
  labelBold?: boolean;
  labelSubRemoveDash?: boolean;
  labelIcon?: string;
  labelIconSize?: number;
  labelIconColor?: string;
  iconButton?: string;
  iconButtonSize?: number;
  iconbuttonColor?: string;
  cta?: string;
  hideCta?: boolean;
  backgroundImagePosition?: string;
  backgroundImageColor?: string;
  backgroundImageOrigin?: string;
  backgroundImagePaddingLeft?: string;
  ctaString?: string;
  optionalIcon?: string;
  cardStyle: 'large' | 'small';
  removeMinHeight?: boolean;
  removeMaxWidth?: boolean;
  marginBottom?: 'medium' | 'large' | 'small';
  data?: any,
  backgroundSize?: string;
  originalItem?: any;
}

@Component({
    selector: 'bw-action-card-legacy',
    templateUrl: './action-card.component.html',
    styleUrls: ['./action-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ActionCardComponentLegacy implements OnInit {
  @Input() cardConfig!: ActionCardConfigInterface;
  @Output() ctaClicked: EventEmitter<any> = new EventEmitter<any>();

  backgroundImg: string;

  constructor() {}

  ngOnInit(): void {
    if (this.cardConfig.image) {
      const imgPath = this.cardConfig.image;
      if (this.isImage(imgPath)) {
        this.backgroundImg = `'url(${this.cardConfig.image})'`;
      } else {
        console.warn('ActionCardComponentLegacy: cardConfig.image must be of image type jpg, jpeg, or png');
      }
    }
  }

  isImage(url: string) {
    return /\.(jpg|jpeg|png)$/.test(url);
  }

  emitCtaClicked(): void {
    this.ctaClicked.emit(true);
  }
}
